import React, { useRef } from "react";
import { makeStyles, Button, Box } from "@material-ui/core";
import InputTextField from "components/input/inputTextField";
import { getLang } from "app/feature/constants";
import DatepickerDialog from "components/dialog/datepicker/datepickerDialog.container";

const useStyle = makeStyles((theme) => ({
  searchContainer: {
    backgroundColor: theme.palette.background.paper,
    display: "grid",
    gridTemplateColumns:
      "minmax(0, 7fr) minmax(0, 3fr) minmax(0, 3fr) minmax(0, 1fr) minmax(0, 1fr)",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  button: {
    [theme.breakpoints.up("sm")]: {
      width: "fit-content",
      justifySelf: "flex-end"
    }
  },
  inputRoot: {
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
    fontSize: "0.875rem",
    fontWeight: "500"
  }
}));

export default function WithDatesSearchComponent({
  handleSearch,
  lang,
  registeredDate,
  setRegisteredDate,
  verifiedDate,
  setVerifiedDate,
  handleClear,
  clearDate
}) {
  const classes = useStyle();
  const textRef = useRef();

  return (
    <Box p={2} mb={1} className={classes.searchContainer}>
      <InputTextField
        variant="filled"
        inputRef={textRef}
        size="small"
        placeholder={getLang(lang, "placeholder.SEARCH")}
        margin="none"
        InputProps={{
          disableUnderline: true,
          margin: "none",
          style: {
            borderRadius: "4px",
            backgroundColor: "#ECEFF0",
          },
          classes: { input: classes.inputRoot },
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter')
            handleSearch(textRef.current.value)
        }}
      />
      <DatepickerDialog
        handleChange={(registeredDate) => {
          setRegisteredDate(registeredDate.format("YYYY-MM-DD HH:mm"));
        }}
        value={registeredDate}
        label={getLang(lang, 'placeholder.REGISTERED_DATE')}
        enableTime={true}
        displayFormat="DD MMMM YYYY HH:mm"
        clearDate={clearDate}
      />
      <DatepickerDialog
        handleChange={(verifiedDate) => {
          setVerifiedDate(verifiedDate.format("YYYY-MM-DD HH:mm"));
        }}
        value={verifiedDate}
        label={getLang(lang, 'placeholder.VERIFIED_DATE')}
        enableTime={true}
        displayFormat="DD MMMM YYYY HH:mm"
        clearDate={clearDate}
      />
      <Button
        color="primary"
        variant="text"
        size="small"
        disableElevation
        onClick={() => {
          textRef.current.value = "";
          handleClear();
        }}
      >
        {getLang(lang, "label.CLEAR")}
      </Button>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        type="submit"
        size="small"
        onClick={() => handleSearch(textRef.current.value)}
      >
        {getLang(lang, "label.SEARCH")}
      </Button>
    </Box>
  );
}
